import React from 'react'
import "./adminnav.css"
import { useNavigate } from 'react-router-dom';
import { useState,useEffect } from 'react';
const Adminnav = () => {
  const [search,setSeach]=useState("")
  var path=window.location.pathname
  var nav=useNavigate()
  function navigate(){
    nav('/Profile')
  }
  function navigateAdminPanel(){
    nav('/AdminPanel')
  }
  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && !(path==='/AdminPanel/AllOrders') && !(path==='/AdminPanel/Coupons/RemoveCoupons')) {
       nav('/SearchResults', { state: { search: search} })
       window.location.reload()
    }
  }
  useEffect(() => {
    if(path==='/AdminPanel/AllOrders'|| path==='/AdminPanel/Coupons/RemoveCoupons')
        searchProduct()
   },[search])
   const searchProduct=()=> {
    var nodes = document.getElementsByClassName('target');
    var i
    for (i = 0; i < nodes.length; i++) {
      var str=search.toLowerCase()
      if (nodes[i].innerText.toLowerCase().includes(str)) {
         if(nodes[i].style.display==="none")
             nodes[i].style=''
      } else {
        nodes[i].style.display = "none";
      }
    }
  }
  return (
    <>
    <div className='row navi gx-0'>
    <div className='col-lg-2 col-md-2 usernav'>
    <img src='https://res.cloudinary.com/vcart/image/upload/v1658298828/Screenshot__131_-removebg-preview_mtjdmd.png' style={{height:"30px", marginTop:"3px"}} alt="VCART" onClick={()=>navigateAdminPanel()}/>
    </div>
    <div className='col-lg-8 col-md-8'>
      <input id='search' className="searchUser" type="text" placeholder="Search for products, brand and more" name="search" value={search} 
      onChange={(e)=>setSeach(e.target.value)} onKeyDown={handleKeyDown}/>
     </div>
    <div className='col-lg-2  col-md-2 adminIcons my-auto'>
     <a onClick={ () =>navigate()}><i className="fas fa-user-circle mx-3"></i></a>
     <a onClick={ () =>navigateAdminPanel()}><i className="fas fa-cog mx-3"></i></a>
    </div>
    </div>
    </>
  )
}

export default Adminnav